import { render, staticRenderFns } from "./productCart.vue?vue&type=template&id=05c22a3e&"
import script from "./productCart.vue?vue&type=script&lang=js&"
export * from "./productCart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports